import React, { useContext } from 'react';
import styles from './WidgetTypeForm.module.scss';
import { SFCheckbox, SFChip } from 'sfui';
import { AppearanceContext } from 'ui-smartforce-settings';
import { WidgetTypeImage } from './WidgetTypeImage/WidgetTypeImage';
import { WidgetSourceTypes } from '../../../../../../Models';

export interface WidgetTypeFormValue {
  id: number;
  label: string;
  sources?: WidgetSourceTypes[];
}

export interface WidgetTypeFormProps {
  type: string;
  widgets: WidgetTypeFormValue[];
  availableSources?: WidgetSourceTypes[];
  value: number[];
  onChange: (id: number, checked: boolean) => void;
}

export const WidgetTypeForm = ({
  type,
  widgets,
  availableSources,
  value,
  onChange
}: WidgetTypeFormProps): React.ReactElement<WidgetTypeFormProps> => {
  const { themeType } = useContext(AppearanceContext);

  const getWidgetSources = (widget: WidgetTypeFormValue) => {
    if (!availableSources) return [];
    return widget.sources
      ? widget.sources.filter((s) => availableSources.includes(s))
      : [...availableSources];
  };

  return (
    <div className={styles.widgetTypeForm}>
      <WidgetTypeImage type={type} isDayMode={themeType === 'day'} />
      <ul className={styles.checkboxList}>
        {widgets.map((w) => (
          <li key={`checkbox-${w.label}`}>
            <SFCheckbox
              label={w.label}
              checked={value.includes(w.id)}
              onChange={(_e, checked) => onChange(w.id, checked)}
            />
            {w.sources && w.sources.length > 0 && (
              <div className={styles.sources}>
                {getWidgetSources(w).map((s) => (
                  <SFChip
                    key={`${w.id}-source-${s}`}
                    className={styles.source}
                    label={s}
                    sfColor={'primary'}
                    variant={'outlined'}
                    size={'tiny'}
                  />
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
